// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '로하스메디',
  targetSheetName: 'Sheet1',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionRate: '수수료율',
  },
  requiredHeaders: [
    '성분명',
    '제약사명',
    '제품명',
    '단가(24.12)',
    '보험코드',
    '급여',
    '수수료율',
    '제품구분',
    '구분',
  ],
});
